// Managed login config (Cognito hosted OAuth code flow). The pool, client, and
// sign-in domain are account-scoped, so this build fails loudly instead of
// silently wiring another environment's identity. No identity pool: no code
// in this app uses AWS credentials, only the bearer token.
const origin =
  typeof window !== 'undefined'
    ? window.location.origin
    : 'http://localhost:3000';

function required(name, value) {
  if (!value?.trim())
    throw new Error(
      `${name} is not set. The factor-listings-app unit declares it in outputEnv; the deploy hydrates it from the identity stack.`,
    );
  return value.trim();
}

const awsmobile = {
  Auth: {
    Cognito: {
      userPoolId: required(
        'REACT_APP_COGNITO_USER_POOL_ID',
        process.env.REACT_APP_COGNITO_USER_POOL_ID,
      ),
      userPoolClientId: required(
        'REACT_APP_COGNITO_CLIENT_ID',
        process.env.REACT_APP_COGNITO_CLIENT_ID,
      ),
      loginWith: {
        oauth: {
          domain: required(
            'REACT_APP_COGNITO_SIGN_IN_DOMAIN',
            process.env.REACT_APP_COGNITO_SIGN_IN_DOMAIN,
          ),
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: [`${origin}/auth/callback`],
          redirectSignOut: [`${origin}/`],
          responseType: 'code',
        },
      },
    },
  },
};

export default awsmobile;
